import { Modal } from 'antd';
import React from 'react';
import { FaCheck, FaExclamationCircle } from 'react-icons/fa';

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(false);

  const handleOkModal = () => {
    setOpen(false);
  };
  const handleCancelMOdal = () => {
    setOpen(false);
  };

  return (
    <Modal
      footer={null}
      visible={props.isModalVisible}
      onOk={props.handleOkModal}
      onCancel={props.handleCancelMOdal}
      width={300}
      // destroyOnClose={true}
    >
      <div class="text-center">
        {props.isError ? (
          <span>
            <FaExclamationCircle className={"alert-msg-icon error"} />
          </span>
        ) : (
          <span class="alert-msg-icon">
            <i class="fa fa-check" aria-hidden="true">
              <FaCheck />
            </i>
          </span>
        )}
        <h4>{props.info}</h4>
        <p>{props.message}</p>
      </div>
    </Modal>
  );
}
